import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { type ChatMessageType } from '../model/chatTypes';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { sender, text, timestamp } = message;
  const time = new Date(timestamp).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

  if (sender === 'system') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5, px: 2 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic', textAlign: 'center' }}>
          {text}
        </Typography>
      </Box>
    );
  }

  const isClient = sender === 'client';

  const getAvatar = () => {
    switch (sender) {
      case 'bot':
        return (
          <Avatar sx={{ width: 28, height: 28, bgcolor: 'grey.400' }}>
            <SmartToyIcon sx={{ fontSize: 18 }} />
          </Avatar>
        );
      case 'operator':
        return (
          <Avatar sx={{ width: 28, height: 28, bgcolor: 'success.main' }}>
            <PersonIcon sx={{ fontSize: 18 }} />
          </Avatar>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isClient ? 'row-reverse' : 'row',
        alignItems: 'flex-end',
        gap: 1,
        px: 2,
        py: 0.5,
      }}
    >
      {!isClient && getAvatar()}
      <Box sx={{ maxWidth: '75%' }}>
        <Box
          sx={{
            px: 1.5,
            py: 1,
            borderRadius: 2,
            bgcolor: isClient
              ? 'primary.main'
              : sender === 'operator'
                ? 'success.light'
                : 'grey.200',
            // Фон бабблов оператора (success.light) и бота (grey.200) одинаков в обеих темах,
            // поэтому текст всегда тёмный (как в светлой теме) — иначе в тёмной теме белый текст
            // text.primary становится нечитаемым на светлом фоне.
            color: isClient ? 'primary.contrastText' : 'grey.800',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
          }}
        >
          <Typography variant="body2">{text}</Typography>
        </Box>
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{
            display: 'block',
            textAlign: isClient ? 'right' : 'left',
            mt: 0.25,
            px: 0.5,
            fontSize: '0.65rem',
          }}
        >
          {time}
        </Typography>
      </Box>
    </Box>
  );
};
